import { createGlobalStyle } from 'styled-components';
import { bodyFont, ink, pop, popDeep, white } from './theme/palette';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    background: ${white};
    font-family: ${bodyFont};
    color: ${ink};
    -webkit-font-smoothing: antialiased;
  }

  a {
    color: ${popDeep};

    &:hover {
      color: ${pop};
    }
  }

  * {
    box-sizing: border-box;
  }
`;

export default GlobalStyle;
